<app-label [label]="name">
  <tui-input
    *ngIf="mode === 'view'"
    class="view value__wrapper"
    [ngModel]="value"
    [tuiTextfieldSize]="size"
    [tuiTextfieldLabelOutside]="true"
    [readOnly]="true"
  >
    {{ name }}
    <input tuiTextfieldLegacy appTestingId="Input.Text" />
  </tui-input>
</app-label>
